//FUNCIONALIDAD DE CONTENEDORES PREGUNTAS
const acordeon = document.getElementsByClassName('cont_faq_res_p');
for (i=0; i<acordeon.length; i++) {
  acordeon[i].addEventListener('click', function () {
    this.classList.toggle('activa');
  });
}

//BOTONES SECCIONES
function activarSeccion(){
  class_activa.classList.toggle('activar');
}

$(".faq_secciones").addClass("pregunta_sec_inactiva");  
$(".sec_envio_entrega").removeClass("pregunta_sec_inactiva");  
$("#btn_sec_entrega").addClass("btn_sec_activo");

//NAVEGACION TERMINOS Y CONDICIONES
$('#btn_sec_pago').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_pago").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_pago").removeClass("pregunta_sec_inactiva");
});  

$('#btn_sec_entrega').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_entrega").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_envio_entrega").removeClass("pregunta_sec_inactiva");
});  

$('#btn_sec_devol').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_devol").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_envio_devoluciones").removeClass("pregunta_sec_inactiva");
});  

$('#btn_sec_prod').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_prod").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_prod").removeClass("pregunta_sec_inactiva");
});  

$('#btn_sec_talla').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_talla").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_tallas").removeClass("pregunta_sec_inactiva");
});  

$('#btn_sec_envio').on('click', function (){
  $(".btn_nav_sec").removeClass("btn_sec_activo");  
  $("#btn_sec_envio").addClass("btn_sec_activo");
  $(".faq_secciones").addClass("pregunta_sec_inactiva");
  $(".sec_localizacion").removeClass("pregunta_sec_inactiva");
});  


//BUSCADOR INTERNO
document.addEventListener("keyup", e =>{
  if(e.target.matches("#busqueda_faq")){
    document.querySelectorAll(".title_faq_principales").forEach( questions => {
      questions.textContent.includes(e.target.value);
      if(questions.textContent.includes(e.target.value) === true){
        questions.classList.remove("no_filtrado");
        $(".faq_secciones").removeClass("pregunta_sec_inactiva");  
      }else{
        questions.classList.add("no_filtrado"); 
      }
    });
  }
});